import * as React from 'react';
import { Header1 } from '@cian/ui-kit/typography';

import { CollapsedBlock, ICollapsedButtonProps } from '../CollapsedBlock';
import * as styles from './styles.css';

export interface IPromos {
  title: string;
  Button: React.ComponentType<ICollapsedButtonProps>;
  onChangeOpen(opened: boolean): void;
}

export function Promos({ title, children, Button, onChangeOpen }: React.PropsWithChildren<IPromos>) {
  return (
    <div data-nav-tab="promoList/Акции" id="promoList" className={styles['nav_container']}>
      <div className={styles['title']}>
        <Header1 as="h2">{title}</Header1>
      </div>
      <CollapsedBlock collapsedHeight={100} Button={Button} onChangeOpen={onChangeOpen} opened={true}>
        <div className={styles['container']}>{children}</div>
      </CollapsedBlock>
    </div>
  );
}
